import { useState, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useFileManagerContext } from '../contexts/FileManagerContext';

export interface FileItem {
  url: string;
}

export interface FileManagerOptions {
  onFileSelect: (file: FileItem) => void;
  type?: 'image' | 'video' | 'all';
}

export const useFileManager = () => {
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const { openFileManager: openContextFileManager } = useFileManagerContext();

  const openFileManager = useCallback(async (options: FileManagerOptions) => {
    if (!user) {
      console.error("L'utilisateur doit être connecté pour utiliser le gestionnaire de fichiers.");
      return;
    }

    setIsLoading(true);
    try {
      // Utiliser le contexte pour ouvrir la modale personnalisée
      openContextFileManager((url) => {
        options.onFileSelect({ url });
      });
    } catch (error) {
      console.error("Erreur lors de l'ouverture du gestionnaire de fichiers:", error);
      alert("Impossible de charger le gestionnaire de fichiers. Veuillez contacter l'assistance.");
    } finally {
      setIsLoading(false);
    }
  }, [user, openContextFileManager]);

  return {
    openFileManager,
    isLoading
  };
};
